import { If } from "components";
import { t } from "i18next";
import { RatingStars } from "ui";

import { OrderStatus } from "../../../../../constants";
import { OrderAtomProps } from "../../OrderModal.types";
import { OrderModalBlock } from "./OrderModalBlock";

import styles from "../../OrderModal.module.scss";

export const OrderFeedback = ({ orderDetails }: OrderAtomProps) => {
  if (
    orderDetails.status !== OrderStatus.Delivered &&
    !orderDetails.status.startsWith("Return")
  )
    return null;

  return (
    <>
      <OrderModalBlock
        className={styles.orderModal__info__feedback}
        label={t("Feedback")}
      >
        {orderDetails.feedback ? (
          <>
            <RatingStars grade={orderDetails.feedback.grade} size={24} />

            <p>{orderDetails.feedback.comment}</p>

            <If condition={orderDetails.feedback.images.length !== 0}>
              <div className={styles.orderModal__info__feedback__images}>
                {orderDetails.feedback.images.map((image) => (
                  <a
                    key={image.id}
                    href={image.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={image.url}
                      className={styles.orderModal__info__feedback__imageItem}
                    />
                  </a>
                ))}
              </div>
            </If>
          </>
        ) : (
          <p className={styles.orderModal__info__feedback__noFeedbackMessage}>
            {t("No feedback yet")}
          </p>
        )}
      </OrderModalBlock>
      <div className={styles.orderModal__separator} />
    </>
  );
};
